import { render, staticRenderFns } from "./ActiveVesselsMap.vue?vue&type=template&id=bfb91ba8&scoped=true"
import script from "./ActiveVesselsMap.vue?vue&type=script&lang=js"
export * from "./ActiveVesselsMap.vue?vue&type=script&lang=js"
import style0 from "./ActiveVesselsMap.vue?vue&type=style&index=0&id=bfb91ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb91ba8",
  null
  
)

export default component.exports